import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { Fragment, useContext, useEffect, useMemo, useState } from 'react'
import { useFieldArray } from 'react-hook-form';
import { TextFieldInputNumber, parseFloatCheckValue, parseFloatNotZero } from '../Ticket/fnTickit';
import _ from "lodash";
import { debounce } from 'lodash';
import { ProviderExpenseActual, arrMock } from './FundExpenseActualForm';
import { FnDialog } from 'utilities/utilities';
import InputReactNumber from '../InputReactNumber';

export default function TableActualFundAdd({ keyId }) {

    const {
        arrMonth,
        calIndexOld,
        form,
        isView
    } = useContext(ProviderExpenseActual);

    const { control, setValue, watch, getValues, reset } = form;
    const { fields } = useFieldArray({
        control,
        name: "lstExpensePlan"
    });

    const watchFieldArray = watch("lstExpensePlan");

    const controlledFields = useMemo(() => {
        return fields.map((field, index) => {
            return {
                ...field,
                ...watchFieldArray[index]
            };
        });
    }, [fields, watchFieldArray])


    const [ObjTotal, setObjTotal] = useState({
        nID: 9999,
        nFundExpenseID: 2,
        sExpense: "รวมค่าใช้จ่าย",
        nParent: null,
        nOrder: 0,
        nTotal: null,
        nQ1: null,
        nQ2: null,
        nQ3: null,
        nQ4: null,
        nTotalActual: null,
        nQ1Actual: null,
        nQ2Actual: null,
        nQ3Actual: null,
        nQ4Actual: null,
        nTotalDiff: null,
        nPercentage: null,
        lstExpenseMonth: _.cloneDeep(arrMock),
        lstActualMonth: _.cloneDeep(arrMock),
        isTotal: true
    })

    useEffect(() => {

        let objTotal = {
            nID: 9999,
            nFundExpenseID: 2,
            sExpense: "รวมค่าใช้จ่าย",
            nParent: null,
            nOrder: 0,
            nTotal: null,
            nQ1: null,
            nQ2: null,
            nQ3: null,
            nQ4: null,
            nTotalActual: null,
            nQ1Actual: null,
            nQ2Actual: null,
            nQ3Actual: null,
            nQ4Actual: null,
            nTotalDiff: null,
            nPercentage: null,
            lstExpenseMonth: _.cloneDeep(arrMock),
            lstActualMonth: _.cloneDeep(arrMock),
            isTotal: true
        }
        if (watchFieldArray != null && watchFieldArray.length > 0) {
            let lstInputMonthTotalPlan = _.cloneDeep(arrMock);
            lstInputMonthTotalPlan.forEach((eleInput: { nOrder: number; value; }) => {
                let sPathValue = `lstExpenseMonth[${eleInput.nOrder - 1}].value`;
                eleInput.value = parseFloatNotZero(_.sumBy(watchFieldArray, (item) => _.get(item, sPathValue, 0)));
            });
            let lstInputMonthTotalActual = _.cloneDeep(arrMock);
            lstInputMonthTotalActual.forEach((eleInput: { nOrder: number; value; }) => {
                let sPathValue = `lstActualMonth[${eleInput.nOrder - 1}].value`;
                eleInput.value = parseFloatNotZero(_.sumBy(watchFieldArray, (item) => _.get(item, sPathValue, 0)));
            });

            objTotal.nTotal = parseFloatNotZero(_.sumBy(watchFieldArray, (item) => _.get(item, 'nTotal', 0)));
            objTotal.nQ1 = parseFloatNotZero(_.sumBy(watchFieldArray, (item) => _.get(item, 'nQ1', 0)));
            objTotal.nQ2 = parseFloatNotZero(_.sumBy(watchFieldArray, (item) => _.get(item, 'nQ2', 0)));
            objTotal.nQ3 = parseFloatNotZero(_.sumBy(watchFieldArray, (item) => _.get(item, 'nQ3', 0)));
            objTotal.nQ4 = parseFloatNotZero(_.sumBy(watchFieldArray, (item) => _.get(item, 'nQ4', 0)));
            objTotal.nTotalActual = parseFloatNotZero(_.sumBy(watchFieldArray, (item) => _.get(item, 'nTotalActual', 0)));
            objTotal.nQ1Actual = parseFloatNotZero(_.sumBy(watchFieldArray, (item) => _.get(item, 'nQ1Actual', 0)));
            objTotal.nQ2Actual = parseFloatNotZero(_.sumBy(watchFieldArray, (item) => _.get(item, 'nQ2Actual', 0)));
            objTotal.nQ3Actual = parseFloatNotZero(_.sumBy(watchFieldArray, (item) => _.get(item, 'nQ3Actual', 0)));
            objTotal.nQ4Actual = parseFloatNotZero(_.sumBy(watchFieldArray, (item) => _.get(item, 'nQ4Actual', 0)));
            objTotal.lstExpenseMonth = lstInputMonthTotalPlan;
            objTotal.lstActualMonth = lstInputMonthTotalActual;
            objTotal.nTotalDiff = objTotal.nTotal - objTotal.nTotalActual;
            objTotal.nPercentage = +objTotal.nTotal !== 0 ?  (objTotal.nTotalActual / objTotal.nTotal) * 100 : 0;
        }

        setObjTotal(objTotal)
    }, [watchFieldArray])

    return (
        <TableContainer id='table-pinned' sx={{ maxHeight: "70vh" }} component={Paper}>
            <Table stickyHeader sx={{ minWidth: 1400 }} >
                <TableHead>
                    <TableRow>
                        <TableCell className="sticky-cell pad-0 head-color head-z400" component="th" padding='none' style={{ minWidth: '440px', width: '440px' }}>
                            <TableCell className='cell-in-sticky border-l head-color' component="th" padding='none' style={{ minWidth: '60px', width: '60px' }}>ลำดับที่</TableCell>
                            <TableCell className='cell-in-sticky border-l head-color' component="th" padding='none' style={{ minWidth: '300px', width: '300px' }}>รายการ</TableCell>
                            <TableCell className='cell-in-sticky border-l head-color' component="th" padding='none' style={{ minWidth: '80px', width: '80px' }}></TableCell>
                        </TableCell>
                        {
                            arrMonth.map((month: string, indexM: number) => {
                                let isFillColor = [3, 7, 11, 15].includes(indexM);
                                return (
                                    <TableCell
                                        key={month}
                                        component="th"
                                        padding='none'
                                        className={isFillColor ? 'head-z300' : "head-color head-z300"}
                                        sx={{
                                            minWidth: '150px',
                                            width: '150px',
                                            backgroundColor: isFillColor ? '#70b603 !important' : "head-color"
                                        }}
                                    >
                                        {month}
                                    </TableCell>
                                )
                            })
                        }
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        controlledFields != null && controlledFields.length > 0 ?
                            <>
                                {controlledFields.map((itemRowLevel1, indexLevel1) => {
                                    let keyCellTable = keyId + itemRowLevel1.nID;
                                    return (
                                        <Fragment key={keyCellTable}>
                                            <ExpenseActualNestedArrayLevel1
                                                keyId={keyId}
                                                itemRowLevel1={itemRowLevel1}
                                                indexLevel1={indexLevel1}
                                                setObjTotal={setObjTotal}
                                                {...{
                                                    control,
                                                    reset,
                                                    getValues,
                                                    watch,
                                                    setValue,
                                                }}
                                            />
                                        </Fragment>
                                    )
                                })}
                                <TableRow sx={{ backgroundColor: '#f2f2f2' }}>
                                    <TableCell className="sticky-cell pad-0 " component="th" padding='none' sx={{ backgroundColor: '#f2f2f2' }} style={{ minWidth: '440px', width: '440px' }}>
                                        <TableCell className='cell-in-sticky border-l' padding='none' component={"th"} align='center' style={{ minWidth: '60px', width: '60px' }}></TableCell>
                                        <TableCell className='cell-in-sticky border-l' padding='none' component={"th"} align='left' style={{ minWidth: '300px', width: '300px' }}>{ObjTotal.sExpense}</TableCell>
                                        <TableCell className='cell-in-sticky border-l' padding='none' component={"th"} align='center' style={{ minWidth: '80px', width: '80px' }}>แผน</TableCell>
                                    </TableCell>
                                    {
                                        ObjTotal.lstExpenseMonth.map((keyRow: { nOrder: string; value: string | number; }, indexMonth: number) => {
                                            let keyCellInput = "plan_" + keyRow.nOrder;
                                            return (
                                                <>
                                                    <TableCell
                                                        key={keyCellInput}
                                                        padding='none'
                                                        component={"th"}
                                                    >
                                                        <TextFieldInputNumber value={keyRow.value} />
                                                    </TableCell>
                                                    {
                                                        [2, 5, 8, 11].includes(indexMonth) ?
                                                            <TableCell
                                                                key={keyCellInput}
                                                                padding='none'
                                                                component={"th"}
                                                            >
                                                                <TextFieldInputNumber value={ObjTotal["nQ" + calIndexOld(indexMonth)]} />
                                                            </TableCell>
                                                            :
                                                            null
                                                    }
                                                    {
                                                        [11].includes(indexMonth) ?
                                                            <TableCell
                                                                padding='none'
                                                                component={"th"}
                                                            >
                                                                <TextFieldInputNumber value={ObjTotal.nTotal} />
                                                            </TableCell>
                                                            :
                                                            null
                                                    }
                                                </>
                                            )
                                        })
                                    }
                                </TableRow>
                                <TableRow>
                                    <TableCell className="sticky-cell pad-0 " component="th" padding='none' sx={{ backgroundColor: '#f2f2f2' }} style={{ minWidth: '440px', width: '440px' }}>
                                        <TableCell className='cell-in-sticky border-l' padding='none' component={"th"} align='center' style={{ minWidth: '60px', width: '60px' }}></TableCell>
                                        <TableCell className='cell-in-sticky border-l' padding='none' component={"th"} align='left' style={{ minWidth: '300px', width: '300px' }}></TableCell>
                                        <TableCell className='cell-in-sticky border-l' padding='none' component={"th"} align='center' style={{ minWidth: '80px', width: '80px' }}>ผล</TableCell>
                                    </TableCell>
                                    {
                                        ObjTotal.lstActualMonth.map((keyRow: { nOrder: string; value: string | number; }, indexMonth: number) => {
                                            let keyCellInput = "key";
                                            return (
                                                <>
                                                    <TableCell
                                                        key={keyCellInput}
                                                        padding='none'
                                                        component={"th"}
                                                    >
                                                        <TextFieldInputNumber value={keyRow.value} />
                                                    </TableCell>
                                                    {
                                                        [2, 5, 8, 11].includes(indexMonth) ?
                                                            <TableCell
                                                                key={keyCellInput}
                                                                padding='none'
                                                                component={"th"}
                                                            >
                                                                <TextFieldInputNumber value={ObjTotal["nQ" + calIndexOld(indexMonth) + "Actual"]} />
                                                            </TableCell>
                                                            :
                                                            null
                                                    }
                                                    {
                                                        [11].includes(indexMonth) ?
                                                            <TableCell
                                                                padding='none'
                                                                component={"th"}
                                                            >
                                                                <TextFieldInputNumber value={ObjTotal.nTotalActual} />
                                                            </TableCell>
                                                            :
                                                            null
                                                    }
                                                </>
                                            )
                                        })
                                    }
                                </TableRow>
                                <TableRow sx={{ backgroundColor: '#fdebd3' }}>
                                    <TableCell className="sticky-cell pad-0 " component="th" padding='none' sx={{ backgroundColor: '#fdebd3' }} style={{ minWidth: '440px', width: '440px' }}>
                                        <TableCell className='cell-in-sticky border-l' padding='none' component={"th"} align='center' style={{ minWidth: '60px', width: '60px' }}></TableCell>
                                        <TableCell className='cell-in-sticky border-l' padding='none' component={"th"} align='left' style={{ minWidth: '300px', width: '300px' }}></TableCell>
                                        <TableCell className='cell-in-sticky border-l' padding='none' component={"th"} align='center' style={{ minWidth: '80px', width: '80px' }}>ส่วนต่าง</TableCell>
                                    </TableCell>
                                    {
                                        ObjTotal.lstActualMonth.map((keyRow: { nOrder: string; value: string | number; }, indexMonth: number) => {
                                            let keyCellInput = "totalActual_" + keyRow.nOrder;
                                            return (
                                                <>
                                                    <TableCell key={keyCellInput} padding='none' component={"th"} > </TableCell>
                                                    {
                                                        [2, 5, 8, 11].includes(indexMonth) ?
                                                            <TableCell
                                                                padding='none'
                                                                component={"th"}
                                                            >
                                                            </TableCell>
                                                            :
                                                            null
                                                    }
                                                    {
                                                        [11].includes(indexMonth) ?
                                                            <TableCell
                                                                padding='none'
                                                                component={"th"}
                                                            >
                                                                <TextFieldInputNumber value={ObjTotal.nTotalDiff} />
                                                            </TableCell>
                                                            :
                                                            null
                                                    }
                                                </>
                                            )
                                        })
                                    }
                                </TableRow>
                                <TableRow sx={{ backgroundColor: '#fdebd3' }}>
                                    <TableCell className="sticky-cell pad-0 " component="th" padding='none' sx={{ backgroundColor: '#fdebd3' }} style={{ minWidth: '440px', width: '440px' }}>
                                        <TableCell className='cell-in-sticky border-l' padding='none' component={"th"} align='center' style={{ minWidth: '60px', width: '60px' }}></TableCell>
                                        <TableCell className='cell-in-sticky border-l' padding='none' component={"th"} align='left' style={{ minWidth: '300px', width: '300px' }}></TableCell>
                                        <TableCell className='cell-in-sticky border-l' padding='none' component={"th"} align='center' style={{ minWidth: '80px', width: '80px' }}>ร้อยละ</TableCell>
                                    </TableCell>
                                    {
                                        ObjTotal.lstActualMonth.map((keyRow: { nOrder: string; value: string | number; }, indexMonth: number) => {
                                            let keyCellInput = "totalActual_" + keyRow.nOrder;
                                            return (
                                                <>
                                                    <TableCell key={keyCellInput} padding='none' component={"th"} > </TableCell>
                                                    {
                                                        [2, 5, 8, 11].includes(indexMonth) ?
                                                            <TableCell
                                                                padding='none'
                                                                component={"th"}
                                                            >
                                                            </TableCell>
                                                            :
                                                            null
                                                    }
                                                    {
                                                        [11].includes(indexMonth) ?
                                                            <TableCell
                                                                padding='none'
                                                                component={"th"}
                                                            >
                                                                <TextFieldInputNumber value={ObjTotal.nPercentage} />
                                                            </TableCell>
                                                            :
                                                            null
                                                    }
                                                </>
                                            )
                                        })
                                    }
                                </TableRow>
                            </>
                            :
                            <TableRow key={"r-no-data"}>
                                <TableCell align="center" colSpan={20}>
                                    ไม่พบข้อมูล
                                </TableCell>
                            </TableRow>
                    }
                </TableBody>
            </Table>
        </TableContainer>

    )
}

function ExpenseActualNestedArrayLevel1({ itemRowLevel1, indexLevel1, setObjTotal, control, setValue, watch, reset, keyId }) {

    const {
        calIndexOld,
        isView,
    } = useContext(ProviderExpenseActual);

    const { fields } = useFieldArray({
        control,
        name: `lstExpensePlan.${indexLevel1}.lstSubLevel`
    });
    const DialogFn = FnDialog();

    const watchFieldArrayHead = watch(`lstExpensePlan`);
    const watchFieldArray = watch(`lstExpensePlan.${indexLevel1}.lstSubLevel`);
    const controlledFieldsLevel2 = useMemo(() => {
        return fields.map((field, index) => {
            return {
                ...field,
                ...watchFieldArray[index]
            };
        });

    }, [fields, watchFieldArray])


    const handleChangeValueLevelOne = (eValue, indexMonth, indexRow, itemTable, keyInput) => {
        handleLevelOneInDebounced.cancel();
        handleLevelOneInDebounced(eValue, indexMonth, indexRow, itemTable, keyInput);
    }

    const handleLevelOneInDebounced = debounce((eValue, indexMonth, keyRow, itemTable, keyInput) => {

        keyRow.value = parseFloatCheckValue(eValue);
        let sumQ1 = parseFloatCheckValue(itemTable.nQ1Actual) ?? 0;
        let sumQ2 = parseFloatCheckValue(itemTable.nQ2Actual) ?? 0;
        let sumQ3 = parseFloatCheckValue(itemTable.nQ3Actual) ?? 0;
        let sumQ4 = parseFloatCheckValue(itemTable.nQ4Actual) ?? 0;
        if ([0, 1, 2].includes(indexMonth)) {
            // Q1
            sumQ1 = _.sumBy(itemTable.lstActualMonth, function (o: { nOrder: number; value; }) { return [1, 2, 3].includes(o.nOrder) ? parseFloatCheckValue(o.value) : 0; });
            itemTable.nQ1Actual = sumQ1;
            setValue(`lstExpensePlan.${indexLevel1}.nQ1Actual`, sumQ1)
        }
        else if ([3, 4, 5].includes(indexMonth)) {
            // Q2
            sumQ2 = _.sumBy(itemTable.lstActualMonth, function (o: { nOrder: number; value; }) { return [4, 5, 6].includes(o.nOrder) ? parseFloatCheckValue(o.value) : 0; });
            itemTable.nQ2Actual = sumQ2;
            setValue(`lstExpensePlan.${indexLevel1}.nQ2Actual`, sumQ2)
        }
        else if ([6, 7, 8].includes(indexMonth)) {
            // Q3
            sumQ3 = _.sumBy(itemTable.lstActualMonth, function (o: { nOrder: number; value; }) { return [7, 8, 9].includes(o.nOrder) ? parseFloatCheckValue(o.value) : 0; });
            itemTable.nQ3Actual = sumQ3;
            setValue(`lstExpensePlan.${indexLevel1}.nQ3Actual`, sumQ3)
        }
        else {
            // Q4
            sumQ4 = _.sumBy(itemTable.lstActualMonth, function (o: { nOrder: number; value; }) { return [10, 11, 12].includes(o.nOrder) ? parseFloatCheckValue(o.value) : 0; });
            itemTable.nQ4Actual = sumQ4;
            setValue(`lstExpensePlan.${indexLevel1}.nQ4Actual`, sumQ4)
        }
        let nTotalActual = sumQ1 + sumQ2 + sumQ3 + sumQ4;
        itemTable.nTotalActual = nTotalActual;

        setValue(`lstExpensePlan.${indexLevel1}.nTotalActual`, nTotalActual)
        handleChangeTotalLevelOne(eValue, indexMonth, keyRow, itemTable, keyInput);
        reset({
            ...watch(),
        });

    }, 200);

    const handleChangeTotalLevelOne = (eValue, indexMonth, keyRow, itemTable, keyInput) => {

        let objTotal = {
            nID: 9999,
            nFundExpenseID: 2,
            sExpense: "รวมค่าใช้จ่าย",
            nParent: null,
            nOrder: 0,
            nTotal: null,
            nQ1: null,
            nQ2: null,
            nQ3: null,
            nQ4: null,
            nTotalActual: null,
            nQ1Actual: null,
            nQ2Actual: null,
            nQ3Actual: null,
            nQ4Actual: null,
            nTotalDiff: null,
            nPercentage: null,
            lstExpenseMonth: _.cloneDeep(arrMock),
            lstActualMonth: _.cloneDeep(arrMock),
            isTotal: true
        }

        if (watchFieldArrayHead != null && watchFieldArrayHead.length > 0) {
            let lstInputMonthTotalPlan = _.cloneDeep(arrMock);
            lstInputMonthTotalPlan.forEach((eleInput: { nOrder: number; value; }) => {
                let sPathValue = `lstExpenseMonth[${eleInput.nOrder - 1}].value`;
                eleInput.value = parseFloatNotZero(_.sumBy(watchFieldArrayHead, (item) => _.get(item, sPathValue, 0)));
            });
            let lstInputMonthTotalActual = _.cloneDeep(arrMock);
            lstInputMonthTotalActual.forEach((eleInput: { nOrder: number; value; }) => {
                let sPathValue = `lstActualMonth[${eleInput.nOrder - 1}].value`;
                eleInput.value = parseFloatNotZero(_.sumBy(watchFieldArrayHead, (item) => _.get(item, sPathValue, 0)));
            });

            objTotal.nTotal = parseFloatNotZero(_.sumBy(watchFieldArrayHead, (item) => _.get(item, 'nTotal', 0)));
            objTotal.nQ1 = parseFloatNotZero(_.sumBy(watchFieldArrayHead, (item) => _.get(item, 'nQ1', 0)));
            objTotal.nQ2 = parseFloatNotZero(_.sumBy(watchFieldArrayHead, (item) => _.get(item, 'nQ2', 0)));
            objTotal.nQ3 = parseFloatNotZero(_.sumBy(watchFieldArrayHead, (item) => _.get(item, 'nQ3', 0)));
            objTotal.nQ4 = parseFloatNotZero(_.sumBy(watchFieldArrayHead, (item) => _.get(item, 'nQ4', 0)));
            objTotal.nTotalActual = parseFloatNotZero(_.sumBy(watchFieldArrayHead, (item) => _.get(item, 'nTotalActual', 0)));
            objTotal.nQ1Actual = parseFloatNotZero(_.sumBy(watchFieldArrayHead, (item) => _.get(item, 'nQ1Actual', 0)));
            objTotal.nQ2Actual = parseFloatNotZero(_.sumBy(watchFieldArrayHead, (item) => _.get(item, 'nQ2Actual', 0)));
            objTotal.nQ3Actual = parseFloatNotZero(_.sumBy(watchFieldArrayHead, (item) => _.get(item, 'nQ3Actual', 0)));
            objTotal.nQ4Actual = parseFloatNotZero(_.sumBy(watchFieldArrayHead, (item) => _.get(item, 'nQ4Actual', 0)));
            objTotal.lstExpenseMonth = lstInputMonthTotalPlan;
            objTotal.lstActualMonth = lstInputMonthTotalActual;
            objTotal.nTotalDiff = objTotal.nTotal - objTotal.nTotalActual;
            objTotal.nPercentage = +objTotal.nTotal !== 0 ?  (objTotal.nTotalActual / objTotal.nTotal) * 100 : 0;

            if (objTotal.nTotalDiff < 0 && eValue !== "0") {
                setValue(keyInput, "0")
                handleLevelOneInDebounced("0", indexMonth, keyRow, itemTable, keyInput);
                DialogFn.Warning("ผลรวมเกินแผนที่ตั้งไว้");
                return false;
            }
        }
        setObjTotal(objTotal)
    }

    return (
        <>
            <TableRow sx={{ backgroundColor: "#ffdbaa" }}>
                <TableCell className="sticky-cell pad-0 " padding='none' sx={{ backgroundColor: '#ffdbaa' }} style={{ minWidth: '440px', width: '440px' }}>
                    <TableCell className='cell-in-sticky border-l' padding='none' align='center' style={{ minWidth: '60px', width: '60px' }}>{indexLevel1 + 1}</TableCell>
                    <TableCell className='cell-in-sticky border-l' padding='none' align='left' style={{ minWidth: '300px', width: '300px' }}>
                        {itemRowLevel1.sExpense}
                    </TableCell>
                    <TableCell className='cell-in-sticky border-l' padding='none' align='center' style={{ minWidth: '80px', width: '80px' }}>แผน</TableCell>
                </TableCell>
                {
                    !itemRowLevel1.lstExpenseMonth ? null :
                        itemRowLevel1.lstExpenseMonth.map((keyRow: { value: string | number; }, indexMonth: number) => {
                            return (
                                <>
                                    <TableCell
                                        padding='none'
                                    >
                                        <TextFieldInputNumber value={keyRow.value} />
                                    </TableCell>
                                    {
                                        [2, 5, 8, 11].includes(indexMonth) ?
                                            <TableCell padding='none'>
                                                <TextFieldInputNumber value={itemRowLevel1["nQ" + calIndexOld(indexMonth)]} />
                                            </TableCell>
                                            :
                                            null
                                    }
                                    {
                                        [11].includes(indexMonth) ?
                                            <TableCell
                                                padding='none'
                                            >
                                                <TextFieldInputNumber value={itemRowLevel1.nTotal} />
                                            </TableCell>
                                            :
                                            null
                                    }
                                </>
                            )
                        })
                }
            </TableRow>
            <TableRow sx={{ backgroundColor: "#ffdbaa" }}>
                <TableCell className="sticky-cell pad-0 " padding='none' sx={{ backgroundColor: '#ffdbaa' }} style={{ minWidth: '440px', width: '440px' }}>
                    <TableCell className='cell-in-sticky border-l' padding='none' align='center' style={{ minWidth: '60px', width: '60px' }}></TableCell>
                    <TableCell className='cell-in-sticky border-l' padding='none' align='left' style={{ minWidth: '300px', width: '300px' }}></TableCell>
                    <TableCell className='cell-in-sticky border-l' padding='none' align='center' sx={{ backgroundColor: "#f7c6cc" }} style={{ minWidth: '80px', width: '80px' }}>ผล</TableCell>
                </TableCell>
                {
                    !itemRowLevel1.lstActualMonth ? null :
                        itemRowLevel1.lstActualMonth.map((keyRow: { value: string | number; isDisable; }, indexMonth: number) => {
                            let sNameInput = `lstExpensePlan[${indexLevel1}].lstActualMonth[${indexMonth}].value`;
                            return (
                                <>
                                    <TableCell padding='none' sx={{ backgroundColor: "#f7c6cc" }} >
                                        <InputReactNumber
                                            id={sNameInput}
                                            name={sNameInput}
                                            defaultValue={keyRow.value}
                                            required={false}
                                            maxInteger={18}
                                            disabled={isView || controlledFieldsLevel2.length !== 0 || keyRow.isDisable === true}
                                            IsCanMinus={false}
                                            IsShowMessageError={false}
                                            onChange={(eValue) => handleChangeValueLevelOne(eValue, indexMonth, keyRow, itemRowLevel1, sNameInput)}
                                        />
                                    </TableCell>
                                    {
                                        [2, 5, 8, 11].includes(indexMonth) ?
                                            <TableCell padding='none' sx={{ backgroundColor: "#f7c6cc" }}>
                                                <TextFieldInputNumber value={itemRowLevel1["nQ" + calIndexOld(indexMonth) + "Actual"]} />
                                            </TableCell>
                                            :
                                            null
                                    }
                                    {
                                        [11].includes(indexMonth) ?
                                            <TableCell padding='none' sx={{ backgroundColor: "#f7c6cc" }}>
                                                <TextFieldInputNumber value={itemRowLevel1.nTotalActual} />
                                            </TableCell>
                                            :
                                            null
                                    }
                                </>
                            )
                        })
                }
            </TableRow>
            {
                controlledFieldsLevel2.map((itemRowLevel2, indexLevel2) => {
                    let keyCellTable = keyId + itemRowLevel2.nID;
                    return (
                        <Fragment key={keyCellTable}>
                            <ExpenseActualNestedArrayLevel23
                                itemRowLevel2={itemRowLevel2}
                                indexLevel1={indexLevel1}
                                indexLevel2={indexLevel2}
                                keyId={keyId}
                                setObjTotal={setObjTotal}
                                {...{
                                    control,
                                    setValue,
                                    watch,
                                    reset
                                }}
                            />
                        </Fragment>
                    )
                })
            }
        </>
    );
}

function ExpenseActualNestedArrayLevel23({ itemRowLevel2, indexLevel1, indexLevel2, setObjTotal, control, setValue, watch, keyId, reset }) {

    const {
        calIndexOld,
        isView,
    } = useContext(ProviderExpenseActual);

    const { fields } = useFieldArray({
        control,
        name: `lstExpensePlan.${indexLevel1}.lstSubLevel.${indexLevel2}.lstSubLevel`
    });
    const DialogFn = FnDialog();

    const watchFieldArrayHead = watch(`lstExpensePlan`);
    const watchFieldArray = watch(`lstExpensePlan.${indexLevel1}.lstSubLevel.${indexLevel2}.lstSubLevel`);

    const controlledFieldsLevel3 = useMemo(() => {
        return fields.map((field, index) => {
            return {
                ...field,
                ...watchFieldArray[index]
            };
        });

    }, [fields, watchFieldArray])

    const handleChangeValueLevelTwo = (eValue, indexMonth, indexRow, itemTable, keyInput) => {
        handleLevelTwoInDebounced.cancel();
        handleLevelTwoInDebounced(eValue, indexMonth, indexRow, itemTable, keyInput);
    }

    const handleLevelTwoInDebounced = debounce((eValue, indexMonth, keyRow, itemTable, keyInput) => {
        keyRow.value = parseFloatCheckValue(eValue);
        let sumQ1 = parseFloatCheckValue(itemTable.nQ1Actual) ?? 0;
        let sumQ2 = parseFloatCheckValue(itemTable.nQ2Actual) ?? 0;
        let sumQ3 = parseFloatCheckValue(itemTable.nQ3Actual) ?? 0;
        let sumQ4 = parseFloatCheckValue(itemTable.nQ4Actual) ?? 0;

        if ([0, 1, 2].includes(indexMonth)) {
            sumQ1 = _.sumBy(itemTable.lstActualMonth, function (o: { nOrder: number; value; }) { return [1, 2, 3].includes(o.nOrder) ? parseFloatCheckValue(o.value) : 0; });
            setValue(`lstExpensePlan.${indexLevel1}.lstSubLevel.${indexLevel2}.nQ1Actual`, sumQ1)
        }
        else if ([3, 4, 5].includes(indexMonth)) {
            sumQ2 = _.sumBy(itemTable.lstActualMonth, function (o: { nOrder: number; value; }) { return [4, 5, 6].includes(o.nOrder) ? parseFloatCheckValue(o.value) : 0; });
            setValue(`lstExpensePlan.${indexLevel1}.lstSubLevel.${indexLevel2}.nQ2Actual`, sumQ2)
        }
        else if ([6, 7, 8].includes(indexMonth)) {
            sumQ3 = _.sumBy(itemTable.lstActualMonth, function (o: { nOrder: number; value; }) { return [7, 8, 9].includes(o.nOrder) ? parseFloatCheckValue(o.value) : 0; });
            setValue(`lstExpensePlan.${indexLevel1}.lstSubLevel.${indexLevel2}.nQ3Actual`, sumQ3)
        }
        else {
            sumQ4 = _.sumBy(itemTable.lstActualMonth, function (o: { nOrder: number; value; }) { return [10, 11, 12].includes(o.nOrder) ? parseFloatCheckValue(o.value) : 0; });
            setValue(`lstExpensePlan.${indexLevel1}.lstSubLevel.${indexLevel2}.nQ4Actual`, sumQ4)
        }
        let nTotalActual = sumQ1 + sumQ2 + sumQ3 + sumQ4;
        itemTable.nTotalActual = nTotalActual;
        setValue(`lstExpensePlan.${indexLevel1}.lstSubLevel.${indexLevel2}.nTotalActual`, nTotalActual)

        let lstExpensePlan = [watch(`lstExpensePlan.${indexLevel1}`)];

        lstExpensePlan.forEach((level1) => {
            let nQ1 = _.sumBy(level1.lstSubLevel, (item) => _.get(item, 'nQ1Actual', 0));
            let nQ2 = _.sumBy(level1.lstSubLevel, (item) => _.get(item, 'nQ2Actual', 0));
            let nQ3 = _.sumBy(level1.lstSubLevel, (item) => _.get(item, 'nQ3Actual', 0));
            let nQ4 = _.sumBy(level1.lstSubLevel, (item) => _.get(item, 'nQ4Actual', 0));
            let nTotal = _.sumBy(level1.lstSubLevel, (item) => _.get(item, 'nTotalActual', 0));
            level1.nQ1Actual = parseFloatNotZero(nQ1);
            level1.nQ2Actual = parseFloatNotZero(nQ2);
            level1.nQ3Actual = parseFloatNotZero(nQ3);
            level1.nQ4Actual = parseFloatNotZero(nQ4);
            level1.nTotalActual = parseFloatNotZero(nTotal);

            level1.lstActualMonth.forEach((eleInput: { nOrder: number; value; }) => {
                let sPathValue = `lstActualMonth[${eleInput.nOrder - 1}].value`;
                eleInput.value = parseFloatNotZero(_.sumBy(level1.lstSubLevel, (item) => _.get(item, sPathValue, 0)));
            });
        });
        handleChangeTotalLevelTwoThree(eValue, indexMonth, keyRow, itemTable, keyInput, 2);

        reset({
            ...watch(),
        });
    }, 200);

    const handleChangeValueLevelThree = (eValue, indexMonth, keyRow, itemTable, indexRow, keyInput) => {
        handleLevelThreeInDebounced.cancel();
        handleLevelThreeInDebounced(eValue, indexMonth, keyRow, itemTable, indexRow, keyInput);
    }

    const handleLevelThreeInDebounced = debounce((eValue, indexMonth, keyRow, itemTable, indexLevel3, keyInput) => {
        keyRow.value = parseFloatCheckValue(eValue);

        let sumQ1 = parseFloatCheckValue(itemTable.nQ1Actual) ?? 0;
        let sumQ2 = parseFloatCheckValue(itemTable.nQ2Actual) ?? 0;
        let sumQ3 = parseFloatCheckValue(itemTable.nQ3Actual) ?? 0;
        let sumQ4 = parseFloatCheckValue(itemTable.nQ4Actual) ?? 0;
        let nTotalCal = 0;
        if ([0, 1, 2].includes(indexMonth)) {
            sumQ1 = _.sumBy(itemTable.lstActualMonth, function (o: { nOrder: number; value; }) { return [1, 2, 3].includes(o.nOrder) ? parseFloatCheckValue(o.value) : 0; });
            setValue(`lstExpensePlan.${indexLevel1}.lstSubLevel.${indexLevel2}.lstSubLevel.${indexLevel3}.nQ1Actual`, sumQ1)
        }
        else if ([3, 4, 5].includes(indexMonth)) {
            sumQ2 = _.sumBy(itemTable.lstActualMonth, function (o: { nOrder: number; value; }) { return [4, 5, 6].includes(o.nOrder) ? parseFloatCheckValue(o.value) : 0; });
            setValue(`lstExpensePlan.${indexLevel1}.lstSubLevel.${indexLevel2}.lstSubLevel.${indexLevel3}.nQ2Actual`, sumQ2)
        }
        else if ([6, 7, 8].includes(indexMonth)) {
            sumQ3 = _.sumBy(itemTable.lstActualMonth, function (o: { nOrder: number; value; }) { return [7, 8, 9].includes(o.nOrder) ? parseFloatCheckValue(o.value) : 0; });
            setValue(`lstExpensePlan.${indexLevel1}.lstSubLevel.${indexLevel2}.lstSubLevel.${indexLevel3}.nQ3Actual`, sumQ3)
        }
        else {
            sumQ4 = _.sumBy(itemTable.lstActualMonth, function (o: { nOrder: number; value; }) { return [10, 11, 12].includes(o.nOrder) ? parseFloatCheckValue(o.value) : 0; });
            setValue(`lstExpensePlan.${indexLevel1}.lstSubLevel.${indexLevel2}.lstSubLevel.${indexLevel3}.nQ4Actual`, sumQ4)
        }
        nTotalCal = sumQ1 + sumQ2 + sumQ3 + sumQ4;
        itemTable.nTotalActual = nTotalCal;
        setValue(`lstExpensePlan.${indexLevel1}.lstSubLevel.${indexLevel2}.lstSubLevel.${indexLevel3}.nTotalActual`, itemTable.nTotalActual)

        // handleChangeTotal(keyInput, handleChangeValueLevelThree("0", indexMonth, keyRow, itemTable, indexLevel3, keyInput));
        //head No dot
        let lstExpensePlanLV2 = [watch(`lstExpensePlan.${indexLevel1}.lstSubLevel.${indexLevel2}`)];
        lstExpensePlanLV2.forEach((level2) => {
            let nQ1 = _.sumBy(level2.lstSubLevel, (item) => _.get(item, 'nQ1Actual', 0));
            let nQ2 = _.sumBy(level2.lstSubLevel, (item) => _.get(item, 'nQ2Actual', 0));
            let nQ3 = _.sumBy(level2.lstSubLevel, (item) => _.get(item, 'nQ3Actual', 0));
            let nQ4 = _.sumBy(level2.lstSubLevel, (item) => _.get(item, 'nQ4Actual', 0));
            let nTotalActual = _.sumBy(level2.lstSubLevel, (item) => _.get(item, 'nTotalActual', 0));
            level2.nQ1Actual = parseFloatNotZero(nQ1);
            level2.nQ2Actual = parseFloatNotZero(nQ2);
            level2.nQ3Actual = parseFloatNotZero(nQ3);
            level2.nQ4Actual = parseFloatNotZero(nQ4);
            level2.nTotalActual = parseFloatNotZero(nTotalActual);

            level2.lstActualMonth.forEach((eleInput: { nOrder: number; value; }) => {
                let sPathValue = `lstActualMonth[${eleInput.nOrder - 1}].value`;
                eleInput.value = parseFloatNotZero(_.sumBy(level2.lstSubLevel, (item) => _.get(item, sPathValue, 0)));
            });
        });

        //head No dot
        let lstExpensePlanLv1 = [watch(`lstExpensePlan.${indexLevel1}`)];
        lstExpensePlanLv1.forEach((level1) => {
            let nQ1 = _.sumBy(level1.lstSubLevel, (item) => _.get(item, 'nQ1Actual', 0));
            let nQ2 = _.sumBy(level1.lstSubLevel, (item) => _.get(item, 'nQ2Actual', 0));
            let nQ3 = _.sumBy(level1.lstSubLevel, (item) => _.get(item, 'nQ3Actual', 0));
            let nQ4 = _.sumBy(level1.lstSubLevel, (item) => _.get(item, 'nQ4Actual', 0));
            let nTotalActual = _.sumBy(level1.lstSubLevel, (item) => _.get(item, 'nTotalActual', 0));
            level1.nQ1Actual = parseFloatNotZero(nQ1);
            level1.nQ2Actual = parseFloatNotZero(nQ2);
            level1.nQ3Actual = parseFloatNotZero(nQ3);
            level1.nQ4Actual = parseFloatNotZero(nQ4);
            level1.nTotalActual = parseFloatNotZero(nTotalActual);

            level1.lstActualMonth.forEach((eleInput: { nOrder: number; value; }) => {
                let sPathValue = `lstActualMonth[${eleInput.nOrder - 1}].value`;
                eleInput.value = parseFloatNotZero(_.sumBy(level1.lstSubLevel, (item) => _.get(item, sPathValue, 0)));
            });
        });

        handleChangeTotalLevelTwoThree(eValue, indexMonth, keyRow, itemTable, keyInput, 3);

        reset({
            ...watch(),
        });
    }, 200);


    const handleChangeTotalLevelTwoThree = (eValue, indexMonth, keyRow, itemTable, keyInput, nLevel) => {

        let objTotal = {
            nID: 9999,
            nFundExpenseID: 2,
            sExpense: "รวมค่าใช้จ่าย",
            nParent: null,
            nOrder: 0,
            nTotal: null,
            nQ1: null,
            nQ2: null,
            nQ3: null,
            nQ4: null,
            nTotalActual: null,
            nQ1Actual: null,
            nQ2Actual: null,
            nQ3Actual: null,
            nQ4Actual: null,
            nTotalDiff: null,
            nPercentage: null,
            lstExpenseMonth: _.cloneDeep(arrMock),
            lstActualMonth: _.cloneDeep(arrMock),
            isTotal: true
        }

        if (watchFieldArrayHead != null && watchFieldArrayHead.length > 0) {
            let lstInputMonthTotalPlan = _.cloneDeep(arrMock);
            lstInputMonthTotalPlan.forEach((eleInput: { nOrder: number; value; }) => {
                let sPathValue = `lstExpenseMonth[${eleInput.nOrder - 1}].value`;
                eleInput.value = parseFloatNotZero(_.sumBy(watchFieldArrayHead, (item) => _.get(item, sPathValue, 0)));
            });
            let lstInputMonthTotalActual = _.cloneDeep(arrMock);
            lstInputMonthTotalActual.forEach((eleInput: { nOrder: number; value; }) => {
                let sPathValue = `lstActualMonth[${eleInput.nOrder - 1}].value`;
                eleInput.value = parseFloatNotZero(_.sumBy(watchFieldArrayHead, (item) => _.get(item, sPathValue, 0)));
            });

            objTotal.nTotal = parseFloatNotZero(_.sumBy(watchFieldArrayHead, (item) => _.get(item, 'nTotal', 0)));
            objTotal.nQ1 = parseFloatNotZero(_.sumBy(watchFieldArrayHead, (item) => _.get(item, 'nQ1', 0)));
            objTotal.nQ2 = parseFloatNotZero(_.sumBy(watchFieldArrayHead, (item) => _.get(item, 'nQ2', 0)));
            objTotal.nQ3 = parseFloatNotZero(_.sumBy(watchFieldArrayHead, (item) => _.get(item, 'nQ3', 0)));
            objTotal.nQ4 = parseFloatNotZero(_.sumBy(watchFieldArrayHead, (item) => _.get(item, 'nQ4', 0)));
            objTotal.nTotalActual = parseFloatNotZero(_.sumBy(watchFieldArrayHead, (item) => _.get(item, 'nTotalActual', 0)));
            objTotal.nQ1Actual = parseFloatNotZero(_.sumBy(watchFieldArrayHead, (item) => _.get(item, 'nQ1Actual', 0)));
            objTotal.nQ2Actual = parseFloatNotZero(_.sumBy(watchFieldArrayHead, (item) => _.get(item, 'nQ2Actual', 0)));
            objTotal.nQ3Actual = parseFloatNotZero(_.sumBy(watchFieldArrayHead, (item) => _.get(item, 'nQ3Actual', 0)));
            objTotal.nQ4Actual = parseFloatNotZero(_.sumBy(watchFieldArrayHead, (item) => _.get(item, 'nQ4Actual', 0)));
            objTotal.lstExpenseMonth = lstInputMonthTotalPlan;
            objTotal.lstActualMonth = lstInputMonthTotalActual;
            objTotal.nTotalDiff = objTotal.nTotal - objTotal.nTotalActual;
            objTotal.nPercentage = +objTotal.nTotal !== 0 ?  (objTotal.nTotalActual / objTotal.nTotal) * 100 : 0;

            if (objTotal.nTotalDiff < 0 && eValue !== "0") {
                setValue(keyInput, "0")
                if (nLevel === 2) {
                    handleLevelTwoInDebounced("0", indexMonth, keyRow, itemTable, keyInput);
                }
                else if (nLevel === 3) {
                    handleLevelThreeInDebounced("0", indexMonth, keyRow, itemTable, keyInput);

                }
                DialogFn.Warning("ผลรวมเกินแผนที่ตั้งไว้");
                return false;
            }
        }
        setObjTotal(objTotal)
    }

    


    return (
        <>
            <TableRow sx={{ backgroundColor: "#f2f2f2" }}>
                <TableCell className="sticky-cell pad-0 " padding='none' sx={{ backgroundColor: '#f2f2f2' }} style={{ minWidth: '440px', width: '440px' }}>
                    <TableCell className='cell-in-sticky border-l' padding='none' align='center' style={{ minWidth: '60px', width: '60px' }}>{indexLevel1 + 1 + "." + (indexLevel2 + 1)}</TableCell>
                    <TableCell className='cell-in-sticky border-l' padding='none' align='left' style={{ minWidth: '300px', width: '300px' }}>
                        {itemRowLevel2.sExpense}
                    </TableCell>
                    <TableCell className='cell-in-sticky border-l' padding='none' align='center' style={{ minWidth: '80px', width: '80px' }}>แผน</TableCell>
                </TableCell>
                {
                    !itemRowLevel2.lstExpenseMonth ? null :
                        itemRowLevel2.lstExpenseMonth.map((keyRow: { value: string | number; }, indexMonth: number) => {
                            return (
                                <>
                                    <TableCell
                                        padding='none'
                                    >
                                        <TextFieldInputNumber value={keyRow.value} />
                                    </TableCell>
                                    {
                                        [2, 5, 8, 11].includes(indexMonth) ?
                                            <TableCell padding='none'>
                                                <TextFieldInputNumber value={itemRowLevel2["nQ" + calIndexOld(indexMonth)]} />
                                            </TableCell>
                                            :
                                            null
                                    }
                                    {
                                        [11].includes(indexMonth) ?
                                            <TableCell
                                                padding='none'
                                            >
                                                <TextFieldInputNumber value={itemRowLevel2.nTotal} />

                                            </TableCell>
                                            :
                                            null
                                    }
                                </>
                            )
                        })
                }
            </TableRow>
            <TableRow sx={{ backgroundColor: "#f2f2f2" }}>
                <TableCell className="sticky-cell pad-0 " padding='none' sx={{ backgroundColor: '#f2f2f2' }} style={{ minWidth: '440px', width: '440px' }}>
                    <TableCell className='cell-in-sticky border-l' padding='none' align='center' style={{ minWidth: '60px', width: '60px' }}></TableCell>
                    <TableCell className='cell-in-sticky border-l' padding='none' align='left' style={{ minWidth: '300px', width: '300px' }}></TableCell>
                    <TableCell className='cell-in-sticky border-l' padding='none' align='center' sx={{ backgroundColor: "#f7c6cc" }} style={{ minWidth: '80px', width: '80px' }}>ผล</TableCell>
                </TableCell>
                {
                    !itemRowLevel2.lstActualMonth ? null :
                        itemRowLevel2.lstActualMonth.map((keyRow: { value: string | number; isDisable }, indexMonth: number) => {
                            let sNameInput = `lstExpensePlan[${indexLevel1}].lstSubLevel[${indexLevel2}].lstActualMonth[${indexMonth}].value`;
                            return (
                                <>
                                    <TableCell padding='none' sx={{ backgroundColor: "#f7c6cc" }} >
                                        <InputReactNumber
                                            id={sNameInput}
                                            name={sNameInput}
                                            defaultValue={keyRow.value}
                                            required={false}
                                            maxInteger={18}
                                            disabled={isView || controlledFieldsLevel3.length !== 0 || keyRow.isDisable === true}
                                            IsCanMinus={false}
                                            IsShowMessageError={false}
                                            onChange={(eValue) => handleChangeValueLevelTwo(eValue, indexMonth, keyRow, itemRowLevel2, sNameInput)}
                                        />
                                    </TableCell>
                                    {
                                        [2, 5, 8, 11].includes(indexMonth) ?
                                            <TableCell padding='none' sx={{ backgroundColor: "#f7c6cc" }}>
                                                <TextFieldInputNumber value={itemRowLevel2["nQ" + calIndexOld(indexMonth) + "Actual"]} />
                                            </TableCell>
                                            :
                                            null
                                    }
                                    {
                                        [11].includes(indexMonth) ?
                                            <TableCell padding='none' sx={{ backgroundColor: "#f7c6cc" }}>
                                                <TextFieldInputNumber value={itemRowLevel2.nTotalActual} />
                                            </TableCell>
                                            :
                                            null
                                    }
                                </>
                            )
                        })
                }
            </TableRow>
            {
                controlledFieldsLevel3.map((itemRowLevel3, indexLevel3) => {
                    let keyCellTable = keyId + itemRowLevel3.nID;
                    return (
                        <Fragment key={keyCellTable}>
                            <TableRow >
                                <TableCell className="sticky-cell pad-0 " padding='none' sx={{ backgroundColor: '#ffffff' }} style={{ minWidth: '440px', width: '440px' }}>
                                    <TableCell className='cell-in-sticky border-l' padding='none' align='center' style={{ minWidth: '60px', width: '60px' }}></TableCell>
                                    <TableCell className='cell-in-sticky border-l' padding='none' align='left' style={{ minWidth: '300px', width: '300px' }}>
                                        {itemRowLevel3.sExpense}
                                    </TableCell>
                                    <TableCell className='cell-in-sticky border-l' padding='none' align='center' style={{ minWidth: '80px', width: '80px' }}>แผน</TableCell>
                                </TableCell>
                                {
                                    !itemRowLevel3.lstExpenseMonth ? null :
                                        itemRowLevel3.lstExpenseMonth.map((keyRow: { value: string | number; name: string; }, indexMonth: number) => {
                                            return (
                                                <>
                                                    <TableCell
                                                        padding='none'
                                                    >
                                                        <TextFieldInputNumber value={keyRow.value} />

                                                    </TableCell>
                                                    {
                                                        [2, 5, 8, 11].includes(indexMonth) ?
                                                            <TableCell padding='none'>
                                                                <TextFieldInputNumber value={itemRowLevel3["nQ" + calIndexOld(indexMonth)]} />
                                                            </TableCell>
                                                            :
                                                            null
                                                    }
                                                    {
                                                        [11].includes(indexMonth) ?
                                                            <TableCell
                                                                padding='none'
                                                            >
                                                                <TextFieldInputNumber value={itemRowLevel3.nTotal} />

                                                            </TableCell>
                                                            :
                                                            null
                                                    }
                                                </>
                                            )
                                        })
                                }
                            </TableRow>
                            <TableRow>
                                <TableCell className="sticky-cell pad-0 " padding='none' sx={{ backgroundColor: '#ffffff' }} style={{ minWidth: '440px', width: '440px' }}>
                                    <TableCell className='cell-in-sticky border-l' padding='none' align='center' style={{ minWidth: '60px', width: '60px' }}></TableCell>
                                    <TableCell className='cell-in-sticky border-l' padding='none' align='left' style={{ minWidth: '300px', width: '300px' }}></TableCell>
                                    <TableCell className='cell-in-sticky border-l' padding='none' align='center' sx={{ backgroundColor: "#f7c6cc" }} style={{ minWidth: '80px', width: '80px' }}>ผล</TableCell>
                                </TableCell>
                                {
                                    !itemRowLevel3.lstActualMonth ? null :
                                        itemRowLevel3.lstActualMonth.map((keyRow: { value: string | number; isDisable }, indexMonth: number) => {
                                            let sNameInput = `lstExpensePlan[${indexLevel1}].lstSubLevel[${indexLevel2}].lstSubLevel[${indexLevel3}].lstActualMonth[${indexMonth}].value`;
                                            return (
                                                <>
                                                    <TableCell padding='none' sx={{ backgroundColor: "#f7c6cc" }} >
                                                        <InputReactNumber
                                                            id={sNameInput}
                                                            name={sNameInput}
                                                            defaultValue={keyRow.value}
                                                            required={false}
                                                            maxInteger={18}
                                                            disabled={isView || keyRow.isDisable === true}
                                                            IsCanMinus={false}
                                                            IsShowMessageError={false}
                                                            onChange={(eValue) => handleChangeValueLevelThree(eValue, indexMonth, keyRow, itemRowLevel3, indexLevel3, sNameInput)}
                                                        />
                                                    </TableCell>
                                                    {
                                                        [2, 5, 8, 11].includes(indexMonth) ?
                                                            <TableCell padding='none' sx={{ backgroundColor: "#f7c6cc" }}>
                                                                <TextFieldInputNumber value={itemRowLevel3["nQ" + calIndexOld(indexMonth) + "Actual"]} />
                                                            </TableCell>
                                                            :
                                                            null
                                                    }
                                                    {
                                                        [11].includes(indexMonth) ?
                                                            <TableCell padding='none' sx={{ backgroundColor: "#f7c6cc" }}>
                                                                <TextFieldInputNumber value={itemRowLevel3.nTotalActual} />
                                                            </TableCell>
                                                            :
                                                            null
                                                    }
                                                </>
                                            )
                                        })
                                }
                            </TableRow>
                        </Fragment>
                    )
                })
            }
        </>
    );
};

